import { Template } from '../templates/types';
import { UploadType } from '../uploads/types';

export type ImportedTemplate = Omit<Template, 'videosCount'> & { videoElementCount: number; correctFile: boolean };

export type DesignFileAnalysis = DesignFileAnalysisGlobal | DesignFileAnalysisLocal;

export type DesignFileAnalysisElement = {
    id: string;
    type: string;
    characterCount?: number;
};

type DesignFileAnalysisBase = {
    type: 'IMAGE';
    fileSize: number;
    designCreationResponses: {
        artboardIndex?: number;
        type: string;
        width: number;
        height: number;
        name: string;
        elements: DesignFileAnalysisElement[];
    }[];
};

export type DesignFileAnalysisLocal = DesignFileAnalysisBase & {
    extension: string;
    fileName: string;
    sourceType: 'INTERNAL';
    fileUrl: string;
    storagePath: string;
};

export type DesignFileAnalysisGlobal = DesignFileAnalysisBase & {
    name: string;
    extensions: string[];
    databaseId: string;
};

export enum ImportType {
    DESIGN_FILE = 'DESIGN_FILE',
    XML = 'XML',
}

export const IMPORT_TARGET_DPI_OPTIONS = [72, 150, 300] as const;

export type ImportTargetDpi = (typeof IMPORT_TARGET_DPI_OPTIONS)[number];

export const IMPORT_BASELINE_DPI: ImportTargetDpi = 72;

export const DEFAULT_IMPORT_TARGET_DPI: ImportTargetDpi = 150;

export type MultiDesignMode = {
    multiDesignMode: boolean;
};

export type ImportTemplateState = {
    type?: ImportType;
    loading: boolean;
    progress: number;
    requestTime?: number;
    template?: ImportedTemplate;
    errors?: any;
    validationErrors: string[];
    cancelImportRequest?: boolean;
    designFileAnalysis?: DesignFileAnalysis;
    addingInProgress: boolean;
    multiDesignMode: boolean;
    targetDpi: ImportTargetDpi;
    pendingUploadForImport?: UploadType;
};

export enum actionTypes {
    IMPORT_TEMPLATE_SET_PENDING_UPLOAD = 'IMPORT_TEMPLATE_SET_PENDING_UPLOAD',
    IMPORT_TEMPLATE_REQUEST = 'IMPORT_TEMPLATE_REQUEST',
    IMPORT_TEMPLATE_SUCCESS = 'IMPORT_TEMPLATE_SUCCESS',
    IMPORT_TEMPLATE_DESIGN_FILE_PROGRESS = 'IMPORT_TEMPLATE_DESIGN_FILE_PROGRESS',
    IMPORT_TEMPLATE_DESIGN_FILE_SUCCESS = 'IMPORT_TEMPLATE_DESIGN_FILE_SUCCESS',
    IMPORT_TEMPLATE_FAILURE = 'IMPORT_TEMPLATE_FAILURE',
    DROP_IMPORTED_TEMPLATE = 'DROP_IMPORTED_TEMPLATE',
    IMPORT_TEMPLATE_CREATE_DESIGNS_REQUEST = 'IMPORT_TEMPLATE_CREATE_DESIGNS_REQUEST',
    IMPORT_TEMPLATE_CREATE_DESIGNS_SUCCESS = 'IMPORT_TEMPLATE_CREATE_DESIGNS_SUCCESS',
    IMPORT_TEMPLATE_CREATE_DESIGNS_FAILURE = 'IMPORT_TEMPLATE_CREATE_DESIGNS_FAILURE',
    IMPORT_TEMPLATE_SET_MULTIDESIGN_MODE = 'IMPORT_TEMPLATE_SET_MULTIDESIGN_MODE',
    IMPORT_TEMPLATE_SET_TARGET_DPI = 'IMPORT_TEMPLATE_SET_TARGET_DPI',
}

export const MAX_INPUT_SIZE = 120;
export const errorKeys = {
    SERVER_ERROR: 'SERVER_ERROR',
    EMPTY_NAME: 'EMPTY_NAME',
    TOO_LONG_NAME: 'TOO_LONG_NAME',
    WRONG_TYPE: 'WRONG_TYPE',
    MIN_DURATION: 'MIN_DURATION',
    MAX_DURATION: 'MAX_DURATION',
    MIN_SIZE: 'MIN_SIZE',
    MAX_SIZE: 'MAX_SIZE',
    MAX_ASSETS: 'MAX_ASSETS',
    MIN_RESOLUTION: 'MIN_RESOLUTION',
    MAX_RESOLUTION: 'MAX_RESOLUTION',
    ODD_RESOLUTION: 'ODD_RESOLUTION',
    NOT_ACCEPTABLE: 'NOT_ACCEPTABLE',
    FAILED: 'FAILED',
};
